<div class="club-post-comment-wrap">
  <span class="club-post-comment-icon"></span>
  <span *ngIf="commentsCount > 0">
    {{ commentsCount }}
  </span>
</div>
